<!--
  +---------------------------------------------------------------------------------------
  | @Author:    xander<luoxingzhang@frippler.com>
  | @Title:     商城管理-订单列表
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="ei-order padding-footer">
    <div class="filter-container">
      <div class="filter-box">
        <div class="filter-item">
          <f-radio-btn-group v-model="query.order_status" :groups="status" @change="fetchData(1)" />
        </div>
        <div class="filter-item">
          <f-date-range-picker v-model="listTime" :shortcuts="[0, -7, -30, -90]" @change="fetchData(1)" />
        </div>
        <div class="filter-item">
          <f-member-selector v-model="query.uid" @change="fetchData(1)" />
        </div>
        <div class="filter-item" style="width: 200px;">
          <el-input v-model="query.keyword" placeholder="订单编号/订单主题" prefix-icon="el-icon-search" clearable
            @change="fetchData(1)" />
        </div>
      </div>
    </div>

    <el-card v-loading="loading" shadow="never">
      <el-table ref="listTable" :data="list" tooltip-effect="dark" class="padding-small">
        <el-table-column label="#" type="index" width="50" />
        <el-table-column :show-overflow-tooltip="true" label="订单编号" min-width="150">
          <template slot-scope="scope">
            <span>{{ scope.row.order_sn }}</span>
          </template>
        </el-table-column>
        <el-table-column width="50" align="right">
          <template slot-scope="scope">
            <f-user-avatar :src="scope.row.avatar" shape="rounded" />
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="付款人" min-width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.nickname }}</span>
          </template>
        </el-table-column>
        <el-table-column :show-overflow-tooltip="true" label="订单主题" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.subject }}</span>
          </template>
        </el-table-column>
        <el-table-column label="实付金额" min-width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.total_payed" class="text-success font-md">￥{{ scope.row.total_payed.toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="商家优惠" min-width="80">
          <template slot-scope="scope">
            <span v-if="(scope.row.total_discount_fee - scope.row.total_credit_fee) > 0" class="font-md">￥{{
              (scope.row.total_discount_fee -
                scope.row.total_credit_fee).toFixed(2) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="平台优惠" min-width="80">
          <template slot-scope="scope">
            <span v-if="scope.row.total_credit_fee > 0" class="font-md">￥{{ scope.row.total_credit_fee.toFixed(2)
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="数量" min-width="80">
          <template slot-scope="scope">
            <span>{{ scope.row.num }}</span>
          </template>
        </el-table-column>
        <el-table-column label="支付时间" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.paytime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" min-width="80">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.order_status == 10">{{ '待发货' }}</el-tag>
            <el-tag type="warning" v-else-if="scope.row.order_status == 20">{{ '待收货' }}</el-tag>
            <el-tag type="success" v-else>{{ '已完成' }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column width="100" label="操作">
          <template slot-scope="scope">
            <el-button v-if="scope.row.orderid" type="text" @click="toOrderDetail(scope.row.orderid)">查看</el-button>
          </template>
        </el-table-column>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt="" class="no-data">
          </div>
        </div>
      </el-table>
    </el-card>
    <div class="foot" :class="!collapse && 'active'">
      <f-table-footer>
        <template slot="right">
          <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
        </template>
      </f-table-footer>
    </div>
    <div>
      <!-- 收支明细详情抽屉 -->
      <el-drawer size="900px" :visible.sync="order_detail" :destroy-on-close="true" :wrapper-closable="true"
        :modal-append-to-body="false" :append-to-body="true" :before-close="handleClose" custom-class="order-detail">
        <div slot="title" class="header">
          <span style="font-size: 16px;color: rgba(48, 49, 51, 1);" class="mr">{{ order_detail_data.order_sn }}</span>
          <span>
            <el-tag type="danger" v-if="order_detail_data.order_status == 10">{{ '待发货' }}</el-tag>
            <el-tag type="warning" v-else-if="order_detail_data.order_status == 20">{{ '待收货' }}</el-tag>
            <el-tag type="success" v-else>{{ '已完成' }}</el-tag>
          </span>
        </div>
        <div class="pl-lg mt mb">
          <div class="mb"><span class="front-line">订单信息</span></div>
          <el-row :gutter="20">
            <el-col :span="12">
              <div class="flex align-items-center">
                <span class="text-muted">订单主题：</span>
                <el-tooltip placement="top" :content="order_detail_data.subject">
                  <span class="content subject" id="subject">{{ order_detail_data.subject }}
                  </span>
                </el-tooltip>
              </div>
              <div class="mt mb">
                <span class="text-muted">支付方式：</span>
                <span class="content">{{ order_detail_data.payment_type }}</span>
              </div>
              <div class="flex align-items-center">
                <span class="text-muted pr hd">付款人：</span>
                <img v-if="payer.avatar" :src="payer.avatar" class="hd avatar" />
                <img v-else src="@/assets/default-avatar.png" class="hd avatar" />
                <span class="content bd ellipsis" style="max-width: 300px;">{{ payer.nickname }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="text-muted">创建时间：</span>
                <span class="content">{{ order_detail_data.createtime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </div>
              <div class="mt mb">
                <span class="text-muted">支付时间：</span>
                <span class="content">{{ order_detail_data.paytime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </div>
              <div>
                <span class="text-muted">成交时间：</span>
                <span class="content">{{ order_detail_data.updatetime | parseTime('{y}/{m}/{d} {h}:{i}') }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-if="order_detail_data.order_type == 3" class="pl-lg mb">
          <div class="mb"><span class="front-line">收货信息</span></div>
          <el-row :gutter="20">
            <el-col :span="12">
              <div>
                <span class="text-muted">收件人：</span>
                <span class="content">{{ shipping_info.contact_man }}</span>
              </div>
              <div class="mt">
                <span class="text-muted">收货地址：</span>
                <span v-if="address.province == address.city" class="content">{{ address.city }}{{
                  address.district }}{{ address.address }}</span>
                <span v-else class="content address">{{ address.province }}{{ address.city }}{{ address.district }}{{
                  address.address }}</span>
              </div>
              <div v-if="order_detail_data.remark" class="mt">
                <span class="text-muted">备注：</span>
                <span>{{ order_detail_data.remark }}</span>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <span class="text-muted">联系电话：</span>
                <span class="content">{{ shipping_info.contact_num }}</span>
              </div>
              <div class="mt mb">
                <span class="text-muted">物流信息：</span>
                <el-button v-if="order_detail_data.order_status == 10" type="danger"
                  @click="deliveryDialogVisible = true">发货</el-button>
                <span v-else-if="order_detail_data.order_status == 20" class="content">{{ order_detail_data.express_name
                }} {{ order_detail_data.express_sn }}
                  <span @click="deliveryDialogVisible = true"><i class="iconfont icon-edit"></i></span>
                </span>
                <span v-else-if="order_detail_data.order_status == 100" class="content">{{ order_detail_data.express_name
                }}{{ order_detail_data.express_sn }}</span>
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="pl-lg mb pr-lg">
          <div class="mb"><span class="front-line">订单明细</span></div>
          <el-scrollbar :native="false" style="height: 580px">
          <el-table ref="listTable" :data="order_items" tooltip-effect="dark" class="padding-mini">
            <el-table-column width="60" type="index" label="#" />
            <el-table-column width="60">
              <template slot-scope="scope">
                <f-user-avatar :src="scope.row.item_thumb" shape="rounded" />
              </template>
            </el-table-column>
            <el-table-column width="240" :show-overflow-tooltip="true" label="商品">
              <template slot-scope="scope">
                <span>{{ scope.row.item_title }}</span>
              </template>
            </el-table-column>
            <el-table-column width="240" :show-overflow-tooltip="true" label="商品属性">
              <template slot-scope="scope">
                <span>{{ scope.row.item_sub_title }}</span>
              </template>
            </el-table-column>
            <el-table-column width="120" :show-overflow-tooltip="true" label="单价">
              <template slot-scope="scope">
                <span>￥{{ scope.row.market_price }}</span>
              </template>
            </el-table-column>
            <el-table-column width="118" :show-overflow-tooltip="true" label="数量">
              <template slot-scope="scope">
                <span>{{ scope.row.num }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="flex mt" style="justify-content:flex-end">
            <div class="flex">
              <div style="line-height: 2em" class="pr text-muted text-right">
                <div>商品总价：</div>
                <div>运费：</div>
                <div v-if="order_detail_data.total_discount_fee - order_detail_data.total_credit_fee > 0">商家优惠：</div>
                <div v-if="order_detail_data.total_credit_fee > 0">平台优惠：</div>
                <div class="total_payed text-success">实付款：</div>
              </div>
              <div style="text-align:right;line-height: 2em">
                <div>{{ order_detail_data.total_market_price | currency }}</div>
                <div>{{ order_detail_data.freight | currency }}</div>
                <div v-if="order_detail_data.total_discount_fee - order_detail_data.total_credit_fee > 0">- {{ (order_detail_data.total_discount_fee - order_detail_data.total_credit_fee) | currency }}</div>
                <div v-if="order_detail_data.total_credit_fee > 0" class="">- {{ order_detail_data.total_credit_fee | currency }}</div>
                <div class="total_payed text-success">{{ order_detail_data.total_payed | currency }}</div>
              </div>
            </div>
          </div>
        </el-scrollbar>
        </div>
      </el-drawer>
      <!-- 修改物流信息弹框 -->
      <el-dialog class="dialog-logistics" title="物流信息" v-loading="shipLoading" :visible.sync="deliveryDialogVisible"
        append-to-body :close-on-click-modal="false" @open="handleDeliveryDialogOpen">
        <el-form :model="formData" label-position="center" ref="postForm" :rules="formRules">
          <el-form-item label="物流公司" label-width="100px" prop="expressid">
            <el-select v-model="formData.expressid" placeholder="请选择物流公司" clearable filterable style="width: 250px">
              <el-option v-for="item in express" :key="item.expressid" :value="item.expressid"
                :label="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="运单号码" label-width="100px">
            <el-input v-model="formData.express_sn" autocomplete="off" clearable style="width: 250px"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="mini" @click="deliveryDialogVisible = false">取 消</el-button>
          <el-button size="mini" type="primary" @click="hanldeUpdateShip">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  getProductOrderListApi,
  eiOrderDeatilApi,
  getDeliveryApi,
  shipProductAPi,
} from "@/api/ei/eiMallApi";
export default {
  data() {
    return {
      loading: false,
      deliveryDialogVisible: false,
      shipLoading: false,
      query: {
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        keyword: null,
        starttime: null,
        endtime: null,
        order_status: null,
        uid: null,
      },
      total: 17,
      list: [],
      listTime: [],
      form: {},
      status: [
        { value: null, title: "全部", separate: true },
        { value: 10, title: "待发货" },
        { value: 20, title: "待收货" },
        { value: 100, title: "已完成" },
      ],
      orderid: 0,
      order_detail: false,
      order_detail_data: {},
      order_items: [],
      payer: {},
      shipping_info: {},
      address: {},
      express: [],
      formData: {
        expressid: null,
        express_sn: "",
      },
      formRules: {
        expressid: [
          { required: true, message: "物流公司不能为空", trigger: "blur" },
        ],
      },
    };
  },

  computed: {
    collapse() {
      return this.$store.state.commonStore.collapse;
    },
  },

  created() {
    const keepAlivePath = ["/ei/product/detail"];
    this.query = this.$utils.initListQuery(this.query, keepAlivePath);
    this.fetchData();
  },

  beforeRouteLeave(to, from, next) {
    this.$utils.saveListQuery(this.query);
    next();
  },

  watch: {
    listTime() {
      if (!this.listTime) {
        this.listTime = [];
        this.query.starttime = null;
        this.query.endtime = null;
        this.fetchData();
      }
      if (this.listTime.length > 0) {
        this.query.starttime = this.listTime[0];
        this.query.endtime = this.listTime[1];
      }
    },
  },

  methods: {
    fetchData(page) {
      if (page) this.query.pindex = page;
      this.loading = true;
      getProductOrderListApi(this.query).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.list = res.data.list;
          this.total = res.data.total;
        } else {
          this.$message.error(res.message);
        }
      });
    },

    fetchDelivery() {
      getDeliveryApi().then((res) => {
        if (!res.errno) {
          this.express = res.data;
        }
      });
    },

    fetchOrderDeatil() {
      eiOrderDeatilApi({ orderid: this.orderid }).then((res) => {
        // this.loading = false
        if (!res.errno) {
          this.order_detail_data = Object.assign({}, res.data);
          this.order_items = res.data.order_items;
          this.payer = Object.assign({}, res.data.payer);
          this.shipping_info = Object.assign({}, res.data.shipping_info);
          this.address = Object.assign({}, res.data.shipping_info.address);
        } else {
          this.$message.error(res.message);
        }
      });
    },

    toOrderDetail(orderid) {
      this.orderid = orderid;
      this.fetchOrderDeatil();
      this.fetchDelivery();
      this.order_detail = true;
    },

    handleDeliveryDialogOpen() {
      this.formData.expressid = this.order_detail_data.expressid;
      this.formData.express_sn = this.order_detail_data.express_sn;
      this.$nextTick(() => {
        this.$refs['postForm'].clearValidate()
      })
    },
    hanldeUpdateShip() {
      this.$refs["postForm"].validate((valid) => {
        if (valid) {
          let obj = {
            orderid: this.orderid,
            expressid: this.formData.expressid,
            express_sn: this.formData.express_sn,
          };
          this.shipLoading = true;

          shipProductAPi(obj)
            .then((res) => {
              this.shipLoading = false;
              if (!res.errno) {
                this.fetchOrderDeatil();
                this.deliveryDialogVisible = false;
                this.$message.success("物流信息修改成功！");
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    handleClose(done) {
      this.order_detail = false
      done();
    },
  },
};
</script>

<style lang="scss">
.ei-order {
  .el-dialog {
    .el-dialog__body {
      padding: 15px !important;
      padding-bottom: 30px;
    }
  }
}

.el-dialog__wrapper.dialog-logistics {
  .el-dialog {
    width: 500px;
  }
}

.order-detail {
  .el-drawer__body {
    overflow: hidden;
  }
  .el-scrollbar__bar.is-vertical {
    display: none;
  }
}
</style>

<style lang="scss" scoped>
.foot {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 240px;
  width: calc(100% - 240px);

  &.active {
    left: 340px;
    width: calc(100% - 340px);
  }
}

/deep/ .el-drawer__header {
  margin-bottom: 0;
  padding-bottom: 20px;
  border: 1px solid rgba(220, 223, 230, 1);

  .el-drawer__close-btn {
    position: absolute;
    top: 20px;
    right: 20px;
  }
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 3px;
  margin-right: 10px;
}

.content {
  height: 40px;
  line-height: 40px;

  &.subject {
    max-width: 270px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}

.total_payed {
  font-size: 16px;
  margin-top: 10px;
}
</style>